import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import { brandLink } from "../../components/PublicLayout";
import SEO from "../../components/SEO";

export default function Blog() {
  const { mode, brand } = useBrand();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const slug = mode === "brand" ? brand.slug : "_all";
    api.get(`/blog?brand_slug=${slug}`).then((r) => setPosts(r.data));
  }, [mode, brand]);

  return (
    <div className="fade-in-up" data-testid="blog-page">
      <SEO title="Blog" />
      <div className="border-b border-white/10 py-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Günlük</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Blog</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {posts.length === 0 ? (
          <div className="text-center py-20 text-zinc-500" data-testid="blog-empty">
            Henüz blog yazısı bulunmuyor.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={brandLink(`/blog/${p.slug}`)}
                className="group block border border-white/10 bg-[#0A0A0A] hover:border-white/30 transition-colors"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="aspect-[16/10] overflow-hidden bg-[#141414]">
                  {p.cover_image ? (
                    <img
                      src={p.cover_image}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-zinc-700 text-xs uppercase tracking-[0.2em]">
                      No Image
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3">
                    {new Date(p.created_at).toLocaleDateString("tr-TR")}
                  </div>
                  <div className="font-display text-lg font-medium leading-tight line-clamp-2">{p.title}</div>
                  <div className="mt-4 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-zinc-400 group-hover:text-white">
                    Devamını Oku <ArrowUpRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
